module.exports = __webpack_public_path__ + "img/核心技术.9f04ab5d.png";